import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
// @ts-ignore
import AwsExports from '../../aws-exports';


@Injectable({
  providedIn: 'root',
})
export class AmplifyApiService {
  constructor() {
    this.configureAmplify();
  }

  configureAmplify() {
    // Append OAuth information to awsConfig
    const updatedAwsConfig = {
      ...AwsExports,
      oauth: {
        ...AwsExports.oauth,
        redirectSignIn: `${window.location.protocol}//${window.location.host}/login`,
      },
    };

    // Configure amplify instance with our info
    Amplify.configure(updatedAwsConfig);
  }

}
